<template>
  <div class="folder-node-checkbox__root">
    <i :class="iconClass" v-on="$listeners" />
  </div>
</template>

<script>
import { SelectionState } from '../../constants/folderTree';

const SelectionStateToIconMapping = {
  [SelectionState.None]: 'mdi-checkbox-blank-outline',
  [SelectionState.MeOnly]: 'mdi-checkbox-marked',
  [SelectionState.MeAndSomeChildren]: 'mdi-checkbox-multiple-marked',
  [SelectionState.NotMeButSomeChildren]: 'mdi-minus-box',
  [SelectionState.NotMeButAllChildren]: 'mdi-minus-box',
  [SelectionState.MeAndAllChildren]: 'mdi-checkbox-multiple-marked',
};

export default {
  props: {
    /**
     * The state of the selection
     */
    state: {
      type: String,
      default: SelectionState.None,
      validator: value => Object.values(SelectionState).includes(value),
    },
    /**
     * If the node has child nodes
     */
    hasChildren: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconClass() {
      return {
        'folder-node-checkbox__checkbox': true,
        mdi: true,
        hasChildren: this.hasChildren,
        [`state_${[this.state]}`]: true,
        [SelectionStateToIconMapping[this.state]]: true,
      };
    },
  },
};
</script>
